var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCornerTwoFrame3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 285,
    viewBox: "0 0 400 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.59 159.613H336.588C371.213 159.613 399.282 187.682 399.282 222.307C399.282 256.931 371.213 285 336.588 285H204.544C170.327 285 142.59 257.263 142.59 223.047V159.613Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M273.895 79.7186L336.589 79.7186L399.282 79.7186C399.282 114.343 371.213 142.412 336.589 142.412C301.964 142.412 273.895 114.343 273.895 79.7186Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.895 62.6935L336.589 62.6935L399.282 62.6935C399.282 28.0688 371.213 2.45385e-06 336.589 5.48084e-06C301.964 8.50782e-06 273.895 28.0688 273.895 62.6935Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.188253 222.123L62.8817 222.123L125.575 222.123C125.575 256.748 97.5064 284.816 62.8817 284.816C28.2571 284.816 0.18825 256.748 0.188253 222.123Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M267.977 136.496L205.283 136.496L142.59 136.496C142.59 101.872 170.659 73.8027 205.283 73.8027C239.908 73.8027 267.977 101.872 267.977 136.496Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerTwoFrame3);
export default __webpack_public_path__ + "static/media/CornerTwoFrame3.78c5a84216bf1b7ff5922b138ad8e6eb.svg";
export { ForwardRef as ReactComponent };